module.exports = __webpack_public_path__ + "img/file.a809a401.svg";